'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';
import { BlurSwap } from '../../collection-showcase/scenes/playback-controls.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import { AppIcon, BusinessIcon } from './business-primitives';
export function AppWindow({
  apps: e,
  active: t,
  pinned: n,
  onOpen: r,
  children: i,
  footer: a,
  titleExtra: o,
  overlay: s,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let c = e.find((e) => e.key === t) ?? e[0];
  return (
    <div
      className={
        'flex h-[600px] overflow-hidden rounded-[10px] bg-[var(--background)] shadow-[var(--sh-1)] md:h-[650px]'
      }
    >
      <nav
        aria-label={translateShowcaseNode(showcaseCopy, 'Pinned apps')}
        className={
          'hidden w-[208px] shrink-0 flex-col gap-px border-r border-[var(--line)] bg-[color-mix(in_oklch,var(--muted)_55%,var(--background))] p-2 md:flex'
        }
      >
        <p className={'text-ink-4 flex h-9 items-center px-2.5 text-[13px]'}>
          {translateShowcaseNode(showcaseCopy, 'Pinned')}
        </p>
        {translateShowcaseNode(
          showcaseCopy,
          n.map((n) => {
            let i = e.find((e) => e.key === n);
            if (!i) return null;
            let a = n === t;
            return (
              <div key={n} className={'bz-grow'}>
                <div className={'min-w-0'}>
                  <button
                    type={'button'}
                    aria-current={a ? 'page' : void 0}
                    onClick={() => r(n)}
                    className={`bz-recv flex h-9 w-full items-center gap-2 rounded-md px-2.5 text-left text-[14px] ${a ? 'text-ink bg-[var(--state-wash)] font-medium' : 'text-ink-2 font-[360] hover:bg-[var(--hover-wash)]'}`}
                  >
                    <AppIcon />
                    <span className={'min-w-0 truncate'}>
                      {translateShowcaseNode(showcaseCopy, i.name)}
                    </span>
                  </button>
                </div>
              </div>
            );
          })
        )}
        <p
          className={'text-ink-4 mt-3 flex h-9 items-center px-2.5 text-[13px]'}
        >
          {translateShowcaseNode(showcaseCopy, 'All apps')}
        </p>
        {translateShowcaseNode(
          showcaseCopy,
          e
            .filter((e) => !n.includes(e.key))
            .map((e) => (
              <button
                key={e.key}
                type={'button'}
                onClick={() => r(e.key)}
                className={`flex h-9 w-full items-center gap-2 rounded-md px-2.5 text-left text-[14px] ${e.key === t ? 'text-ink bg-[var(--state-wash)] font-medium' : 'text-ink-2 font-[360] hover:bg-[var(--hover-wash)]'}`}
              >
                <AppIcon />
                <span className={'min-w-0 truncate'}>
                  {translateShowcaseNode(showcaseCopy, e.name)}
                </span>
              </button>
            ))
        )}
      </nav>
      <div className={'relative flex min-w-0 flex-1 flex-col'}>
        <div
          className={
            'flex h-[52px] shrink-0 items-center gap-2.5 border-b border-[var(--line)] pr-2 pl-4'
          }
        >
          <AppIcon className={'size-5'} />
          <span className={'text-ink min-w-0 truncate text-[14px] font-medium'}>
            <BlurSwap value={c?.name ?? ''} />
          </span>
          <span className={'text-ink-3 ml-auto flex items-center gap-1'}>
            {translateShowcaseNode(showcaseCopy, o)}
            <span
              className={
                'hidden h-8 items-center rounded-lg bg-[var(--muted)] p-[3px] text-[12.5px] font-medium sm:flex'
              }
            >
              <span
                className={
                  'text-ink flex h-[26px] items-center rounded-md bg-[var(--background)] px-2.5 shadow-[0_1px_2px_rgb(0_0_0/0.08)]'
                }
              >
                {translateShowcaseNode(showcaseCopy, 'View')}
              </span>
              <span className={'flex h-[26px] items-center px-2.5'}>
                {translateShowcaseNode(showcaseCopy, 'Chat')}
              </span>
            </span>
            <span className={'hidden size-8 place-items-center lg:grid'}>
              <BusinessIcon name={'more'} className={'size-4'} />
            </span>
            <span className={'grid size-8 place-items-center'}>
              <ShowcaseIcon name={'x'} className={'size-4'} />
            </span>
          </span>
        </div>
        <div className={'min-h-0 flex-1 overflow-hidden'}>
          {translateShowcaseNode(showcaseCopy, i)}
        </div>
        {translateShowcaseNode(
          showcaseCopy,
          s ? (
            <div
              className={
                'absolute top-[56px] right-2 z-20 w-[min(384px,calc(100%-16px))]'
              }
            >
              {translateShowcaseNode(showcaseCopy, s)}
            </div>
          ) : null
        )}
        <div
          className={
            'pointer-events-none absolute inset-x-0 bottom-0 bg-[linear-gradient(to_top,var(--background)_55%,transparent)] px-3 pt-8 pb-3 md:px-6 md:pb-4'
          }
        >
          {translateShowcaseNode(showcaseCopy, a)}
        </div>
      </div>
    </div>
  );
}
export const tr = {
  real: 'Real \xB7 showcase workspace',
  built: 'Built by IMAI \xB7 sample data',
  illustrative: 'Illustrative',
};
export function AppSourceBadge({ kind: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <span
      className={`flex h-6 items-center rounded-full px-2.5 text-[12px] whitespace-nowrap ${e === 'real' ? 'bg-[var(--primary)] text-[var(--primary-foreground)]' : 'text-ink-3 bg-[var(--tint-2)]'}`}
    >
      {translateShowcaseNode(showcaseCopy, tr[e])}
    </span>
  );
}
export const reference_facts_i = {
  pricing: {
    checked: 'October 6, 2026',
    rows: [
      {
        brand: 'Quince',
        product: 'European Linen Chore Jacket',
        price: 70,
      },
      {
        brand: 'COS',
        product: 'Grandad-Collar Linen Overshirt',
        price: 150,
        sale: 90,
      },
      {
        brand: 'Mango',
        product: '100% Linen Overshirt',
        price: 139.99,
      },
      {
        brand: 'Wax London',
        product: 'Aldred Linen-Cotton Overshirt',
        price: 225,
        sale: 101.25,
      },
      {
        brand: 'Oliver Sweeney',
        product: 'Rauceby Linen Overshirt',
        price: 230,
      },
      {
        brand: 'Banana Republic',
        product: 'Italian Linen-Cotton Shirt Jacket',
        price: 250,
      },
    ],
    target: {
      low: 145,
      high: 165,
      start: 149,
    },
  },
  planner: {
    styles: 8,
    avgMargin: 61.9,
    byStatus: {
      Concept: 2,
      'Tech pack': 2,
      Sampling: 2,
      Approved: 2,
    },
    rows: [
      {
        style: 'Cairn unlined jacket',
        category: 'Jackets',
        colour: 'Driftwood',
        retail: 189,
        cost: 82,
        margin: 56.6,
        status: 'Concept',
      },
      {
        style: 'Fjord boxy overshirt',
        category: 'Overshirts',
        colour: 'Deep Fjord',
        retail: 149,
        cost: 58,
        margin: 61.1,
        status: 'Sampling',
      },
      {
        style: 'Harbour drawstring trouser',
        category: 'Trousers',
        colour: 'Driftwood',
        retail: 129,
        cost: 47,
        margin: 63.6,
        status: 'Tech pack',
      },
      {
        style: 'Kelp pull-on short',
        category: 'Shorts',
        colour: 'Clay',
        retail: 89,
        cost: 31,
        margin: 65.2,
        status: 'Concept',
      },
      {
        style: 'Lantern camp-collar shirt',
        category: 'Shirts',
        colour: 'Sea Fog',
        retail: 109,
        cost: 38,
        margin: 65.1,
        status: 'Approved',
      },
      {
        style: 'Skerry relaxed shirt',
        category: 'Shirts',
        colour: 'Flax',
        retail: 119,
        cost: 42,
        margin: 64.7,
        status: 'Approved',
      },
    ],
  },
  timings: {
    brandKit: '2m 28s',
    directions: '3m 39s',
    channelReply: '28s',
    pricingScan: '2m 4s',
  },
};
export const l = reference_facts_i;
export const rr = l.planner;
export const ir = Object.keys(rr.byStatus).filter((e) => e in rr.byStatus);
export const ar = ['All', ...ir];
export const reference_facts_r = {
  name: 'Halden',
  positioning: 'Linen-first, relaxed, coastal-Nordic, mid-price.',
  line: 'Dress for the weather, not the occasion.',
  palette: [
    {
      name: 'Flax',
      hex: '#EAE3D3',
    },
    {
      name: 'Driftwood',
      hex: '#B9AB92',
    },
    {
      name: 'Sea Fog',
      hex: '#8FA3A8',
    },
    {
      name: 'Deep Fjord',
      hex: '#23383F',
    },
    {
      name: 'Clay',
      hex: '#B86B4B',
    },
  ],
  type: {
    display: 'Cormorant Garamond',
    text: 'DM Sans',
  },
  builtIn: 'under three minutes',
};
export const p = reference_facts_r;
export const or = new Map(p.palette.map((e) => [e.name, e.hex]));
export const sr =
  'text-[11px] leading-4 tracking-[0.12em] uppercase text-ink-3';
export function AppMetric({ label: e, value: t, className: n = '' }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={`rounded-[10px] px-4 py-3 shadow-[inset_0_0_0_1px_var(--border)] ${n}`}
    >
      <dt className={`${sr} truncate`}>
        {translateShowcaseNode(showcaseCopy, e)}
      </dt>
      <dd
        className={
          'num text-ink mt-1.5 font-[Georgia,serif] text-[24px] leading-none md:text-[26px]'
        }
      >
        {translateShowcaseNode(showcaseCopy, t)}
      </dd>
    </div>
  );
}
